import { render, staticRenderFns } from "./MMP_Deliveries.vue?vue&type=template&id=d1c52034&scoped=true&"
import script from "./MMP_Deliveries.vue?vue&type=script&lang=js&"
export * from "./MMP_Deliveries.vue?vue&type=script&lang=js&"
import style0 from "./MMP_Deliveries.vue?vue&type=style&index=0&id=d1c52034&prod&lang=css&"
import style1 from "./MMP_Deliveries.vue?vue&type=style&index=1&id=d1c52034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c52034",
  null
  
)

export default component.exports